<div style="padding: 0px 0px 0px 10px">
	<p-table
		#mydt
		[value]="lstGeoFence"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedGeoFences"
		dataKey="GeoFenceID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--GeoFenceDesc-->
				<th>
					<p-columnFilter type="text" field="GeoFenceDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SeverityDesc-->
				<th>
					<p-columnFilter field="SeverityDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSeverityDesc
								[ngModel]="value"
								[options]="lstSeverityDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--AlertComments-->
				<th>
					<p-columnFilter type="text" field="AlertComments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox (click)="onHeaderCheckboxToggle($event)"></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="GeoFenceDesc">Description<p-sortIcon field="GeoFenceDesc"></p-sortIcon></th>
				<th pSortableColumn="Severity">Severity<p-sortIcon field="Severity"></p-sortIcon></th>
				<th pSortableColumn="AlertComments">Comments<p-sortIcon field="AlertComments"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>

				<th></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-GeoFence>
			<tr [pSelectableRow]="GeoFence">
				<td>
					<p-tableCheckbox [pSelectableRow]="GeoFence" [value]="GeoFence"></p-tableCheckbox>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ GeoFence[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="GeoFence.Active == true ? 'Black' : 'Red'">
					{{ GeoFence["ActiveDesc"] }}
				</td>

				<td>
					<button *ngIf="IsEditing(GeoFence.GeoFenceID) == false" class="btn btn-primary" (click)="onEdit(GeoFence)">Edit</button>
					<button *ngIf="IsEditing(GeoFence.GeoFenceID) == true" class="btn btn-success" (click)="onSave(GeoFence)">Save</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
